// extracted by css-extract-rspack-plugin
export default {"measure":"zaqoIS","label":"Pjjarl"};